'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var defineProperty = require('../../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var ButtonBase = require('./ButtonBase.js');
var errorTheme = require('../../../Styles/errorTheme.js');
var newErrorTheme = require('../../../Styles/newErrorTheme.js');
var useHCWebExperiment = require('../../../../utils/useHCWebExperiment.js');
var withHCUIExperiment = require('../../../../utils/withHCUIExperiment.js');
var ButtonV2 = require('./ButtonV2.js');
var ThemeProvider = require('../../../../node_modules/@material-ui/styles/esm/ThemeProvider/ThemeProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Button = function Button(props) {
  var _ref = props || {},
      color = _ref.color,
      variant = _ref.variant,
      version = _ref.version;

  var theme = version ? newErrorTheme.newErrorTheme : errorTheme.errorTheme;

  if (color === 'error') {
    return React__default["default"].createElement(ThemeProvider, {
      theme: theme
    }, React__default["default"].createElement(ButtonBase, _objectSpread({}, props, {
      "data-ds-version": "v1"
    })));
  }

  if (variant === 'flat') {
    return React__default["default"].createElement(ButtonBase, _objectSpread({
      variant: "text"
    }, props, {
      "data-ds-version": "v1"
    }));
  }

  return React__default["default"].createElement(ButtonBase, _objectSpread({}, props, {
    "data-ds-version": "v1"
  }));
};

var DESIGN_SYSTEM_BUTTON_V2_FEATURE_FLAG = 'design-system-button-v2';
var ExperimentButton = withHCUIExperiment({
  ExperimentalComponent: ButtonV2["default"],
  experimentName: DESIGN_SYSTEM_BUTTON_V2_FEATURE_FLAG,
  experimentVariantName: 'on',
  experimentFn: useHCWebExperiment
})(Button);
var ButtonComponent = Button;

exports.ButtonComponent = ButtonComponent;
exports["default"] = ExperimentButton;
